import { Icon, type IconProps } from './Icon';

/**
 * Two stacked cards (Figma 702:4741) — the "Potential Hits" affordance in the
 * modern pack header. Exact Figma glyph, drawn FILLED in `currentColor` (the
 * Figma `fill="white"` becomes currentColor so it stays themeable). The 50%
 * opacity from the design is applied by the caller via an `opacity-50` class,
 * not baked in here — so it isn't double-dimmed.
 */
export function Cards(props: IconProps) {
  return (
    <Icon fill="currentColor" stroke="none" {...props}>
      <path d="M11.2207 5.71777C12.9505 5.71797 14.3522 7.12074 14.3524 8.85057V20.4066C14.3539 22.1378 12.95 23.5403 11.2207 23.5405H4.28685C2.55671 23.5405 1.15405 22.1378 1.15405 20.4077V8.85057C1.15427 7.12062 2.55684 5.71777 4.28685 5.71777H11.2207Z" />
      <path d="M9.64722 2.32327C10.0954 0.653304 11.8131 -0.340504 13.4841 0.107447L13.4832 0.108424L20.1814 1.90237L20.4871 2.001C21.97 2.5651 22.8159 4.17197 22.3962 5.73928L19.405 16.9024C19.0031 18.401 17.5797 19.352 16.0837 19.208V8.85159C16.0834 6.16667 13.907 3.98764 11.2205 3.98733H9.2019L9.64722 2.32327Z" />
    </Icon>
  );
}
